module.exports = __webpack_public_path__ + "static/media/technical-support.4b453ea7.png";